<template>
  <div class="v2026-ai-card v2026-aifc-tx" role="status" aria-live="polite">

    <template v-if="companyAddresses.length">
      <div class="v2026-aifc__result-title">ข้อมูลขอใบกำกับภาษีที่ AI วิเคราะห์ได้</div>
      <div class="v2026-aifc__text">ลูกค้าเคยมีที่อยู่บริษัทสำหรับออกใบกำกับภาษีแล้ว</div>
      <div class="v2026-aifc__list">
        <div class="v2026-aifc__listrow" v-for="(companyAddress, index) in companyAddresses" :key="index">
          <div class="v2026-aifc__strong">{{ companyAddress.company }}</div>
          <div class="v2026-aifc__meta" v-if="companyAddress.tax_id">
            เลขประจำตัวผู้เสียภาษี {{ companyAddress.tax_id }}
          </div>
        </div>
      </div>
      <div class="v2026-aifc__text">ตรวจสอบและออกใบกำกับภาษีแบบเต็มได้ที่</div>
      <a class="v2026-aifc__link" :href="receiptUrl" :title="receiptUrl"
         target="_blank" rel="noopener noreferrer">
        <span>เปิดหน้าใบเสร็จ/ใบกำกับภาษี</span>
        <span class="v2026-ai-mask v2026-aifc__link-ico" aria-hidden="true"
              :style="maskStyle(icons.externalLink)"></span>
      </a>
      <div class="v2026-aifc__meta" v-if="email">โดยใช้อีเมล {{ email }}</div>
    </template>

    <template v-else>
      <div class="v2026-aifc__result-title">ลูกค้ายังไม่เคยมีที่อยู่บริษัทสำหรับออกใบกำกับภาษี</div>
      <template v-if="userId">
        <div class="v2026-aifc__text">สร้างที่อยู่บริษัทได้ในโปรไฟล์ลูกค้า</div>
        <div class="v2026-aifc__meta">หัวข้อ "ที่อยู่บริษัท (สำหรับออกใบกำกับภาษีคุณลูกค้าทั่วไป)"</div>
        <a class="v2026-aifc__link" :href="userProfileUrl" :title="userProfileUrl"
           target="_blank" rel="noopener noreferrer">
          <span>เปิดโปรไฟล์ลูกค้า #{{ userId }}</span>
          <span class="v2026-ai-mask v2026-aifc__link-ico" aria-hidden="true"
                :style="maskStyle(icons.externalLink)"></span>
        </a>
      </template>
    </template>

  </div>
</template>

<script>
export default {
  name: 'tax-invoice-result-v2026',
  props: {
    // vuex state (aiAssistant.fcResult) — read-only.
    result: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      icons: {
        externalLink: require('@/assets/icons2026/external-link.svg')
      },
      receiptUrl: 'https://admin-test.beneat.co/receipt'
    }
  },
  computed: {
    companyAddresses () {
      const list = this.result && this.result.user_company_addresses
      return Array.isArray(list) ? list : []
    },
    email () {
      return (this.result && this.result.params && this.result.params.email) || null
    },
    userId () {
      return (this.result && this.result.user_id) || null
    },
    userProfileUrl () {
      return this.userId ? `https://admin-test.beneat.co/user/${this.userId}` : null
    }
  },
  methods: {
    maskStyle (url) {
      return {
        '-webkit-mask-image': 'url(' + url + ')',
        'mask-image': 'url(' + url + ')'
      }
    }
  }
}
</script>

<style scoped>
.v2026-ai-mask {
  display: inline-block;
  -webkit-mask-repeat: no-repeat;
          mask-repeat: no-repeat;
  -webkit-mask-position: center;
          mask-position: center;
  -webkit-mask-size: contain;
          mask-size: contain;
  background-color: var(--v2026-icon);
}
.v2026-ai-card {
  background: var(--v2026-surface-sunken);
  border-radius: var(--v2026-r-card);
}

.v2026-aifc-tx {
  display: flex;
  flex-direction: column;
  gap: var(--v2026-sp-2);
  padding: var(--v2026-sp-3) var(--v2026-sp-4);
}

.v2026-aifc__result-title {
  font-size: var(--v2026-fs-body);
  font-weight: 600;
  color: var(--v2026-text);
  line-height: 1.5;
  word-break: break-word;
}
.v2026-aifc__text {
  font-size: var(--v2026-fs-body);
  color: var(--v2026-text-secondary);
  line-height: 1.5;
  word-break: break-word;
}
.v2026-aifc__strong {
  font-size: var(--v2026-fs-body);
  font-weight: 600;
  color: var(--v2026-text);
  line-height: 1.5;
  word-break: break-word;
}
.v2026-aifc__meta {
  font-size: var(--v2026-fs-meta);
  color: var(--v2026-text-muted);
  line-height: 1.5;
  word-break: break-word;
}

.v2026-aifc__list {
  background: var(--v2026-surface);
  border-radius: var(--v2026-r-card);
  overflow: hidden;
}
.v2026-aifc__listrow {
  padding: var(--v2026-sp-2) var(--v2026-sp-3);
  border-bottom: 1px solid var(--v2026-border);
}
.v2026-aifc__listrow:last-child {
  border-bottom: 0;
}

.v2026-aifc__link {
  display: inline-flex;
  align-items: center;
  gap: var(--v2026-sp-2);
  font-size: var(--v2026-fs-body);
  color: var(--v2026-link);
  line-height: 1.5;
  word-break: break-word;
}
.v2026-aifc__link:hover {
  text-decoration: underline;
}
.v2026-aifc__link:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px rgba(49, 193, 215, 0.30);
  border-radius: 4px;
}
.v2026-aifc__link-ico {
  width: 14px;
  height: 14px;
  flex: 0 0 auto;
  background-color: currentColor;
}
</style>
